import React from 'react';
import { useTranslation } from 'react-i18next';
import Layout from '../components/Layout';
import Back1 from '../assets/images/back-home-1.webp';
import SEO from '../components/SEO';
import AnalisisPage from '../pages/AnalisisPage';

export const AnalisisCredito = () => {
  const { t, i18n } = useTranslation();
  return (
    <Layout backgroundimage={Back1} actionDemo={false}>
      <SEO
        title={t("Solución integral de análisis crediticio automatizada.")}
        description={t('Toma decisiones financieras acertadas con nuestro análisis de crédito y score alternativo. Reduce riesgos y mejora la calidad crediticia.')}
        bolImage={false}
        works={[
          t('Core Financiero'),
          t('Fintech'),
          t('Onboarding digital'),
          t('Aprobación de crédito'),
          t('Gestión de cobranza'),
          t('Análisis de crédito'),
          t('Core Bancario'),
          t('Automatización de procesos'),
          t('Procesos digitales'),
          t('Producto financiero'),
          t('Servicios financieros'),
          t('Digitalización de procesos'),
          t('Software financiero'),
          t('Dispersión'),
          t('Reportes automatizados'),
          t('Corebanking'),
          t('Sector financiero'),
          t('SOFIPO'),
          t('SOFOM'),
          t('CNBV'),
          t('Condusef'),
          t('Servicios financieros digitales'),
          t('Plataforma financiera'),
        ]}
        ogImage={`dynamicore-preview.png`}
        twitterImage={`dynamicore-preview.png`}
        canonicalUrl={`https://dynamicore.io/${i18n.language === 'en' ? 'en/credit-analysis' : 'analisis-crediticio'}`}
        hreflang={[
          { url: "https://dynamicore.io/analisis-crediticio", lang: "es" },
          { url: "https://dynamicore.io/en/credit-analysis", lang: "en-us" }
        ]}
      />
      <AnalisisPage/>
    </Layout>
  )
}
